import React from 'react'
import ReactDOM from 'react-dom/client'

import './assets/scss/index.scss'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { useAuthProvider } from './services/security/hooks/authProvider' 
import { Provider as ReduxStoreProvider } from 'react-redux'
import { store } from './store'
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js'
import { reactPlugin } from './hooks/appInsights'
import { Error } from './pages/Error/Error'

const { AuthProvider } = useAuthProvider();

const root = ReactDOM.createRoot(document.getElementById('root')!)


root.render(
  <ReduxStoreProvider store={store}>
    <React.StrictMode>
        <AuthProvider>
          <BrowserRouter basename="/">
            <AppInsightsErrorBoundary onError={() => <Error/>} appInsights={reactPlugin}>
              <App />
            </AppInsightsErrorBoundary>
          </BrowserRouter>
        </AuthProvider>
    </React.StrictMode>
  </ReduxStoreProvider>
)